export const CATEGORY_CLASSNAME = "App\\Entity\\Site\\Category";
